/*eslint-disable*/ import React from "react";
import { Helmet } from "react-helmet";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// core components
import Footer from "components/Footer/Footer";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import SportappHeader from "customComponents/SportappHeader/Header";
import Parallax from "components/Parallax/Parallax";

import landingPageStyle from "assets/jss/material-kit-pro-react/views/landingPageStyle.js";

import ClubList from "./ClubList";

import ssbBackground from "customAssets/img/ssb_background.png";
import ssbLogo from "customAssets/img/ssb_logo.png";
import codecentricLogo from "customAssets/img/codecentric_logo.png";

const styles = () => {
	return {
		...landingPageStyle,
		logoImg: {
			width: "100%",
			height: "auto",
		},
		container: {
			...landingPageStyle.container,
			paddingTop: 10,
		},
		textCenter: {
			textAlign: "center",
		},
	};
};

const useStyles = makeStyles(styles);
export default function ClubsPage() {
	React.useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
	}, []);

	const classes = useStyles();
	return (
		<div>
			<Helmet>
				<title>Solingen Sportapp</title>
			</Helmet>
			<SportappHeader />
			<Parallax image={ssbBackground} filter="dark">
				<div className={classes.container}>
					<GridContainer justifyContent="center">
						<GridItem xs={10} sm={8} md={6}>
							<img src={ssbLogo} className={classes.logoImg} />
						</GridItem>
						<GridItem
							xs={10}
							sm={10}
							md={10}
							className={classNames(classes.textCenter)}
						>
							<br />
							<h3>
								Die <b>Solingen Sportapp</b> bietet Dir eine Übersicht über alle
								Solinger Vereine und deren Aktivitäten.
							</h3>
							<br />
						</GridItem>
						<GridItem
							xs={8}
							sm={4}
							md={4}
							className={classNames(classes.textCenter)}
						>
							<div>
								Mit freundlicher Unterstützung der{" "}
								<a
									target="_blank"
									rel="noreferrer"
									href="https://www.codecentric.de"
								>
									<img src={codecentricLogo} className={classes.logoImg} />
								</a>
							</div>
						</GridItem>
					</GridContainer>
				</div>
			</Parallax>
			<div className={classNames(classes.main, classes.mainRaised)}>
				<div className={classes.container}>
					<ClubList />
				</div>
			</div>
			<Footer
				content={
					<div>
						<div className={classes.left}>
							<List className={classes.list}>
								<ListItem className={classes.inlineBlock}>
									<a href="/impressum/" className={classes.block}>
										Impressum
									</a>
								</ListItem>
								<ListItem className={classes.inlineBlock}>
									<a href="/datenschutz/" className={classes.block}>
										Datenschutzerklärung
									</a>
								</ListItem>
							</List>
						</div>
						<div className={classes.right}>
							&copy; {1900 + new Date().getYear()} Solinger Sportbund e.V.
						</div>
					</div>
				}
			/>
		</div>
	);
}

ClubsPage.propTypes = {
	classes: PropTypes.object,
};
